import { render, staticRenderFns } from "./titleText.vue?vue&type=template&id=2b1f07bf&scoped=true&"
import script from "./titleText.vue?vue&type=script&lang=js&"
export * from "./titleText.vue?vue&type=script&lang=js&"
import style0 from "./titleText.vue?vue&type=style&index=0&id=2b1f07bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f07bf",
  null
  
)

export default component.exports